// extracted by mini-css-extract-plugin
module.exports = {"root":"accordion-with-image_root__by0eU","title":"accordion-with-image_title__62VNQ"};